import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const interstitialsContract = c.router(
  {
    /**
     * Returns whether the user-registration interstitial wizard should be
     * shown to the current user for the current tenant. Single source of
     * truth combining user- and tenant-level checks so clients never have to
     * reassemble them from several queries.
     */
    getUserRegistrationShouldShow: {
      method: 'GET',
      path: '/user-registration/should-show',
      responses: {
        200: z.object({
          shouldShow: z.boolean(),
        }),
      },
    },
  },
  {
    pathPrefix: '/:tenantId/interstitials',
  },
);
